import { z } from 'zod'

export const ENV_SCHEMA = {
    REACT_APP_LOCAL: z.enum(['yes', 'no']), // debug flag
    REACT_APP_ENVIRONMENT: z.enum(['development', 'staging', 'production']), // environment name
    REACT_APP_ORNA_BACKEND_URL: z
        .string()
        .url('ORNA Backend Endpoint must be a valid URL'), // backend
    REACT_APP_THEIA_SERVER_URL: z
        .string()
        .url('ORNA Backend Endpoint must be a valid URL'), // theia
    // theia-agent (Theia chat); defaults to /theia-agent next to REACT_APP_THEIA_SERVER_URL
    REACT_APP_THEIA_AGENT_URL: z
        .union([
            z.literal(''),
            z.string().url('Theia agent endpoint must be a valid URL'),
        ])
        .optional(),
    REACT_APP_GOOGLE_CAPTCHA_SITE_KEY: z.string(), // captcha
    REACT_APP_STRIPE_PUBLIC_KEY: z.string(), // stripe
    REACT_APP_SENTRY_DSN: z.string(), // sentry

    /**
     *------------
     * Auth0
     *------------
     */
    REACT_APP_AUTH0_DOMAIN: z.string(),
    REACT_APP_AUTH0_CLIENTID: z.string(),
    REACT_APP_AUTH0_AUDIENCE: z.string(),

    /**
     *------------
     * Hasura
     *------------
     */
    REACT_APP_GRAPHQL_ENDPOINT: z
        .string()
        .url('Graphql endpoint must be a valid URL'),
    REACT_APP_WS_GRAPHQL_ENDPOINT: z
        .string()
        .url('Graphql WS endpoint must be a valid URL'),
    REACT_APP_GRAPHQL_ERROR_POLICY: z.string(),
}
